import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';

// Context
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';

// Components
import EANotebook from './components/EANotebook';

// Config
import { amplifyConfig } from './config/amplify-config';

// Configure Amplify
Amplify.configure(amplifyConfig);

const LanguageSwitch: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <div style={{ display: 'flex', borderRadius: '4px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.3)' }}>
      <button
        onClick={() => setLanguage('ja')}
        style={{
          padding: '4px 8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '0.75rem',
          fontWeight: 600,
          backgroundColor: language === 'ja' ? '#fbbf24' : 'transparent',
          color: language === 'ja' ? '#1a202c' : 'rgba(255,255,255,0.7)',
        }}
      >
        JP
      </button>
      <button
        onClick={() => setLanguage('en')}
        style={{
          padding: '4px 8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '0.75rem',
          fontWeight: 600,
          backgroundColor: language === 'en' ? '#fbbf24' : 'transparent',
          color: language === 'en' ? '#1a202c' : 'rgba(255,255,255,0.7)',
        }}
      >
        EN
      </button>
    </div>
  );
};

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { signOut, user } = useAuth();
  const { t } = useLanguage();

  return (
    <div>
      <header style={{
        height: '58px',
        background: 'linear-gradient(90deg, #1e1b4b 0%, #312e81 55%, #4338ca 100%)',
        padding: '0 22px',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 10px rgba(15,23,42,0.25)',
        position: 'relative',
        zIndex: 10,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Link to="/" style={{ textDecoration: 'none', color: 'white', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{
              width: '34px',
              height: '34px',
              borderRadius: '10px',
              backgroundColor: 'rgba(255,255,255,0.14)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.15rem',
            }}>📚</span>
            <h1 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700, letterSpacing: '-0.01em' }}>
              {t('header', 'title')}
            </h1>
            <span style={{
              fontSize: '0.62rem',
              fontWeight: 700,
              padding: '2px 8px',
              borderRadius: '10px',
              backgroundColor: 'rgba(251,191,36,0.18)',
              color: '#fcd34d',
              letterSpacing: '0.06em',
            }}>TOGAF / ADM</span>
          </Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <span style={{ fontSize: '0.82rem', opacity: 0.85 }}>
            {user?.email || user?.username || t('header', 'user')}
          </span>
          <LanguageSwitch />
          <button
            onClick={signOut}
            style={{
              padding: '7px 16px',
              backgroundColor: 'rgba(255,255,255,0.12)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.25)',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '0.8rem',
              fontWeight: 600
            }}
          >
            {t('header', 'logout')}
          </button>
        </div>
      </header>
      <main style={{ minHeight: 'calc(100vh - 58px)', backgroundColor: '#f1f5f9' }}>
        {children}
      </main>
    </div>
  );
};

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AuthProvider>
      <MainLayout>
        {children}
      </MainLayout>
    </AuthProvider>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={
            <ProtectedRoute>
              <EANotebook />
            </ProtectedRoute>
          } />
          <Route path="/notebook/:notebookId" element={
            <ProtectedRoute>
              <EANotebook />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
